import React from 'react';
import RedirectLinkComponent from '../../../../Elements/RedirectLinkComponent';
import { formatProjectLabel } from '../../../../Helpers/invoiceAutomationEditorHelper';

// A job's project in the automatic invoicing History, as "#id name", opening it on the Third-Party Projects page in a
// new tab, as the job and the invoice next to it do. A job without a project, or deleted since, shows nothing.
export default function InvoiceAutomationProjectId({ projectId = null, projectName = null }) {
  if (!projectId) {
    return null;
  }

  return (
    <RedirectLinkComponent
      isFigmaStyle={true}
      path='new_projects'
      tooltipText={projectId}
      text={formatProjectLabel(projectId, projectName)}
      keyValuePairs={[
        { key: 'SelectedOfficeId', value: '' },
        { key: 'ProjectIdOrName', value: projectId },
      ]}
    />
  );
}
